var _defs, _use;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrow2 = function SvgArrow2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6 9.245 1.577 5 6 .755 5.214 0 1.438 3.62a1.891 1.891 0 0 0 0 2.76L5.214 10 6 9.245Z",
    id: "arrow2_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#C2C2C2",
    transform: "matrix(-1 0 0 1 6 0)",
    xlinkHref: "#arrow2_svg__a",
    fillRule: "evenodd"
  })));
};

export default SvgArrow2;